export default __webpack_public_path__ + "assets/94447c95d491d123309c34da539f0e12.svg";